import React from 'react';
import PropTypes, { any } from 'prop-types';

import styles from './courtSchedular.scss';

const InlineScores = ({ scores }) => {
    if (!scores || scores.length === 0) {
        return null;
    }

    return (
        <span className={styles.inlineScores}>
            {scores.map((scoreItem) => (
                <span
                    key={scoreItem.id}
                    className={`${styles.inlineSetScore} ${scoreItem.isHigher ? styles.winnerScore : ''}`}
                >
                    {scoreItem.score != null ? scoreItem.score : 0}
                    {scoreItem.tiebreakValue != null && (
                        <sup className={styles.tiebreakSup}>{scoreItem.tiebreakValue}</sup>
                    )}
                </span>
            ))}
        </span>
    );
};

InlineScores.propTypes = {
    scores: PropTypes.arrayOf(any),
};

InlineScores.defaultProps = {
    scores: null,
};

export default InlineScores;
